import { Reducer } from 'redux';
import { TicketInfoActionTypes, TicketInfoState, initialState } from './types';

const reducer: Reducer<TicketInfoState> = (state = initialState, action) => {
  switch (action.type) {
    case TicketInfoActionTypes.UPDATE_TICKETINFO: {
      return {
        ...state,
        infoo: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
